import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { AccessTokensAccessLayout } from 'pages/settings/pages/developer/pages/accessTokens/layout/AccessTokensAccessLayout'
import { AccessTokensPageLayout } from 'pages/settings/pages/developer/pages/accessTokens/layout/AccessTokensPageLayout'
import { AccessTokensPage } from 'pages/settings/pages/developer/pages/accessTokens/ui/accessTokensPage'

export const AccessTokensRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<AccessTokensAccessLayout />}>
        <Route element={<AccessTokensPageLayout />}>
          <Route path={'/'} element={<AccessTokensPage />} />
        </Route>
      </Route>
    </RoutesWithNotFound>
  )
}
